<template>
  <div>
    <slot />
    <Teleport to="body">
      <AuthModal 
        v-if="showModal" 
        @close="handleClose"
        @auth-success="handleAuthSuccess"
        :initial-email="initialEmail"
        :initial-tab="initialTab"
      />
    </Teleport>
  </div>
</template>

<script>
import AuthModal from './AuthModal.vue';
import { ref, provide, nextTick } from 'vue';

export default {
  name: 'LoginModalWrapper',
  
  components: {
    AuthModal
  },
  
  setup() {
    const showModal = ref(false);
    const initialEmail = ref('');
    const initialTab = ref('login');
    
    const openLoginModal = (options = {}) => {
      initialEmail.value = options.email || '';
      initialTab.value = options.tab || 'login';
      showModal.value = true;
    };
    
    const handleClose = async () => {
      showModal.value = false;
      
      // Wait for modal to fully close before resetting state
      await nextTick();
      
      // Add a small delay to ensure DOM cleanup completes
      setTimeout(() => {
        initialEmail.value = '';
        initialTab.value = 'login';
      }, 100);
    };
    
    const handleAuthSuccess = (user) => {
      handleClose();
      
      // Emit custom event that vanilla JS can listen to
      window.dispatchEvent(new CustomEvent('login-success', { detail: user }));
    };
    
    // Make the openLoginModal function available globally
    window.openLoginModal = openLoginModal;
    
    // Also make specific helper functions available
    window.openLoginModalForSignIn = (email) => {
      openLoginModal({ email, tab: 'login' });
    };
    
    window.openLoginModalForRegister = (email) => {
      openLoginModal({ email, tab: 'register' });
    };
    
    window.openLoginModalForPasswordReset = (email) => {
      openLoginModal({ email, tab: 'forgot' });
    };
    
    // Provide for child components if needed
    provide('openLoginModal', openLoginModal);
    
    return {
      showModal,
      handleClose,
      handleAuthSuccess,
      initialEmail,
      initialTab
    };
  }
};
</script>